import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { IdentificationSection } from '../components/sections/IdentificationSection';
import { DifferentiatingStatement } from '../components/sections/DifferentiatingStatement';
import { TruthShiftSection } from '../components/sections/TruthShiftSection';
import { PromiseSection } from '../components/sections/PromiseSection';
import { SystemSection } from '../components/sections/SystemSection';
import { CreatorSection } from '../components/sections/CreatorSection';
import { ImagineSection } from '../components/sections/ImagineSection';
import { BonusesSection } from '../components/sections/BonusesSection';
import { ConfrontationBlock } from '../components/sections/ConfrontationBlock';
import { ValueAnchorSection } from '../components/sections/ValueAnchorSection';
import { InvestmentSection } from '../components/sections/InvestmentSection';
import { GuaranteeSection } from '../components/sections/GuaranteeSection';
import { FAQSection } from '../components/sections/FAQSection';
import { FinalCTASection } from '../components/sections/FinalCTASection';
export function LandingPage() {
  return <main className="w-full overflow-x-hidden" data-id="element-150">
      <HeroSection data-id="element-151" />
      <IdentificationSection data-id="element-152" />
      <DifferentiatingStatement data-id="element-153" />
      <TruthShiftSection data-id="element-154" />
      <PromiseSection data-id="element-155" />
      <SystemSection data-id="element-156" />
      <CreatorSection data-id="element-157" />
      <ImagineSection data-id="element-158" />
      <BonusesSection data-id="element-159" />
      <ConfrontationBlock data-id="element-160" />
      <ValueAnchorSection data-id="element-161" />
      <InvestmentSection data-id="element-162" />
      <GuaranteeSection data-id="element-163" />
      <FAQSection data-id="element-164" />
      <FinalCTASection data-id="element-165" />

      <footer className="py-8 text-center text-sm text-text-secondary/50 bg-ivory border-t border-border-custom" data-id="element-166">
        <p data-id="element-167">
          © {new Date().getFullYear()} ProMind Energy. Todos los derechos
          reservados.
        </p>
      </footer>
    </main>;
}